import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import Button from '../../../Button'
import Text from '../../../Text'
import { PROFILE_CONTACTS_WIDGET_QA_NAME } from '../ProfileContactsWidget.constants'
import { getContactQaName } from '../ProfileContactsWidget.utils'
import { ProfileContactsWidgetLabel } from '../ProfileContactsWidgetLabel'
import { ProfileContactsWidgetListCellViewButtons } from '../ProfileContactsWidgetListCellViewButtons'
import { ProfileContactsWidgetListCellViewRowWrapper } from '../ProfileContactsWidgetListCellViewRowWrapper'

import * as styles from './ProfileContactsWidgetListCellView.module.css'

function ProfileContactsWidgetListCellView({
  canEdit,
  floatingTooltip,
  infoTooltipKey,
  isCopied,
  label,
  link,
  noValueText,
  qaId,
  target,
  value,
  onClickValue,
  onCopy,
  onEdit,
}) {
  return (
    <div className={styles.content}>
      <ProfileContactsWidgetLabel
        className={styles.label}
        infoTooltipKey={infoTooltipKey}
        label={label}
      />
      <div className={styles.row}>
        {noValueText ? (
          <Text disabled isSecondary className={styles.noValueText}>
            {noValueText}
          </Text>
        ) : onClickValue ? (
          <Button.Text
            className={styles.textButton}
            qaName={getContactQaName({
              id: qaId,
              qaName: PROFILE_CONTACTS_WIDGET_QA_NAME.emailButton,
            })}
            tooltip={floatingTooltip}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            onClick={onClickValue}
          >
            <Text className={styles.text}>{value}</Text>
          </Button.Text>
        ) : (
          <ProfileContactsWidgetListCellViewRowWrapper
            className={styles.link}
            floatingTooltip={floatingTooltip}
            link={link}
            target={target}
          >
            <Text className={styles.text}>{value}</Text>
          </ProfileContactsWidgetListCellViewRowWrapper>
        )}
        <ProfileContactsWidgetListCellViewButtons
          canCopy={!noValueText}
          canEdit={canEdit}
          className={styles.buttons}
          isCopied={isCopied}
          qaId={qaId}
          onCopy={onCopy}
          onEdit={onEdit}
        />
      </div>
    </div>
  )
}

export default ProfileContactsWidgetListCellView
